import { render, staticRenderFns } from "./AppleLabelGrid.vue?vue&type=template&id=64055cd0&"
import script from "./AppleLabelGrid.vue?vue&type=script&lang=js&"
export * from "./AppleLabelGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports